import type { IPathBaseParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import type { IInteractiveExamResponse } from "@api/courses/exams/interactive/types";
import type { IInteractiveExamGetAllParams } from "@api/interactiveExams/types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IInteractiveExamResponse>>,
  IPathBaseParam,
  IPaginationParams & IInteractiveExamGetAllParams
>("interactiveExams");

export const interactiveExams = {
  ...getAllApis,
};
